import { IDataCommand, IDataExecutor } from './data-transformer.interface';

export class DataExecutor implements IDataExecutor {
  execute<TIn, TInConfig, TOut>(command: IDataCommand<TIn, TInConfig, TOut>, data: TIn, config: TInConfig): TOut {
    return command.process(data, config);
  }
}
